// outboxActions.js
import config from "../../../config";
import axiosInstance from "../../../services/AxiosInstance";
import {
  OUTBOX_FETCH_REQUEST,
  OUTBOX_FETCH_SUCCESS,
  OUTBOX_FETCH_FAILURE,
  OUTBOX_RETRY_REQUEST,
  OUTBOX_RETRY_SUCCESS,
  OUTBOX_RETRY_FAILURE,
  OUTBOX_SET_FILTERS,
  OUTBOX_SET_AUTO_REFRESH,
  OUTBOX_CLEAR_ERROR,
  OUTBOX_PREVIEW_REQUEST,
  OUTBOX_PREVIEW_SUCCESS,
  OUTBOX_PREVIEW_FAILURE,
  OUTBOX_CLEAR_PREVIEW,
} from "./outboxTypes";

// Action Creators
export const fetchOutboxRequest = () => ({
  type: OUTBOX_FETCH_REQUEST,
});

export const fetchOutboxSuccess = (messages) => ({
  type: OUTBOX_FETCH_SUCCESS,
  payload: messages,
});

export const fetchOutboxFailure = (error) => ({
  type: OUTBOX_FETCH_FAILURE,
  payload: error,
});

export const retryMessageRequest = () => ({
  type: OUTBOX_RETRY_REQUEST,
});

export const retryMessageSuccess = (messageId) => ({
  type: OUTBOX_RETRY_SUCCESS,
  payload: messageId,
});

export const retryMessageFailure = (error) => ({
  type: OUTBOX_RETRY_FAILURE,
  payload: error,
});

export const previewMessageRequest = () => ({
  type: OUTBOX_PREVIEW_REQUEST,
});

export const previewMessageSuccess = (messageDetails) => ({
  type: OUTBOX_PREVIEW_SUCCESS,
  payload: messageDetails,
});

export const previewMessageFailure = (error) => ({
  type: OUTBOX_PREVIEW_FAILURE,
  payload: error,
});

export const clearPreview = () => ({
  type: OUTBOX_CLEAR_PREVIEW,
});

export const setOutboxFilters = (filters) => ({
  type: OUTBOX_SET_FILTERS,
  payload: filters,
});

export const setAutoRefresh = (enabled) => ({
  type: OUTBOX_SET_AUTO_REFRESH,
  payload: enabled,
});

export const clearOutboxError = () => ({
  type: OUTBOX_CLEAR_ERROR,
});

// Thunk Actions
export const fetchOutboxMessages = () => {
  return async (dispatch) => {
    dispatch(fetchOutboxRequest());

    try {
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;
      console.log(token);
      const data = await axiosInstance({
        url: config.routes.fetchOutboxApi,
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("data", data);

      dispatch(fetchOutboxSuccess(data?.data?.result || []));
    } catch (error) {
      const apiError = {
        message: "Failed to fetch outbox messages",
        code: "FETCH_ERROR",
      };
      dispatch(fetchOutboxFailure(apiError));
    }
  };
};

export const retryMessage = (messageId) => {
  return async (dispatch) => {
    const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
      ?.token;
    console.log(token);

    dispatch(retryMessageRequest());

    try {
      const data = await axiosInstance({
        url: config.routes.retryMessageApi(messageId),
        method: "post",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch(retryMessageSuccess(messageId));
    } catch (error) {
      const apiError = {
        message: "Failed to retry message",
        code: "RETRY_ERROR",
      };
      dispatch(retryMessageFailure(apiError));
    }
  };
};

// Preview message by ID from Redux state (no API call needed)
export const previewMessage = (messageId) => {
  return async (dispatch, getState) => {
    dispatch(previewMessageRequest());

    try {
      const state = getState();
      const message = state.outbox.messages.find((m) => m.id === messageId);

      if (message) {
        // Simulate API delay for better UX
        await new Promise((resolve) => setTimeout(resolve, 100));

        dispatch(previewMessageSuccess(message));
      } else {
        const apiError = {
          message: "Message not found",
          code: "MESSAGE_NOT_FOUND",
        };
        dispatch(previewMessageFailure(apiError));
      }
    } catch (error) {
      const apiError = {
        message: "Failed to preview message",
        code: "PREVIEW_ERROR",
      };
      dispatch(previewMessageFailure(apiError));
    }
  };
};
